<template>
    <div class="modal" v-if="modal.isOpen" @click="checkTarget">
        <div class="modal-container">
            <component
                :is="modal.component"
                :componentProps="modal.componentProps"
            ></component>
        </div>
    </div>
</template>
<script>
import { useModalStore } from "@/vue/stores/modal";

export default {
    data() {
        return {
            modal: useModalStore(),
        };
    },
    methods: {
        checkTarget(e) {
            e.preventDefault();
            if (e && e.target) {
                if (e.target.classList.contains("modal")) {
                    this.modal.close();
                }
            }
        },
    },
};
</script>
<style>
.modal {
    position: fixed;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.2);
    backdrop-filter: blur(5px);
}

.modal-container {
    background-color: var(--color-white);
    padding: var(--grid-gap);
    box-shdaow: 0px 3px 6px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
}
</style>
